// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__27ImW","imageUploader":"EGiftCard_imageUploader__2crPk"};